import React, { useState, useEffect } from 'react'
import { Container, OutlinedInput, Box, Grid, TextField, Typography, Button, InputLabel, FormControl, Select, MenuItem } from '@mui/material/'
import { useFetch } from '../../hooks/useFetch'
import SelectTitle from '../SelectTitle'
import SelectNationality from '../SelectNationality'
import { TitleOutlined } from '@mui/icons-material'
import DoneOutlineIcon from '@mui/icons-material/DoneOutline'
import { useAuthContext } from '../../hooks/useAuthContext'
import CancelIcon from '@mui/icons-material/Cancel'
import SendIcon from '@mui/icons-material/Send'
import CircularProgress from '@mui/material/CircularProgress'
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import DeleteIcon from '@mui/icons-material/Delete';
function RemoveCouse({ setRemove, handleCompelte, removeId }) {

    const { user, parentID } = useAuthContext()



    const { error, errorMessage, isPending, data } = useFetch(`https://dcregapi.bi-oss.co.za/quote/quotedetails/${removeId}`)
    const { deleteData, error: error2, isPending: isPending2, data: updatedData } = useFetch(`https://dcregapi.bi-oss.co.za/quote/remove/${removeId}`, 'DELETE')

    const [success, setSuccess] = useState(0)
    const [courseCode, setCourseCode] = useState('')
    const [courseName, setCourseName] = useState('')


    useEffect(() => {
        if (data) {
            data.map(data => {
                setCourseCode(data.courseCode)
                setCourseName(data.courseName)

            })
        }
    }, [data])

    const handleSubmit = (e) => {

        e.preventDefault()

        deleteData()
    }


    useEffect(() => {


        if (updatedData) {

            handleCompelte()
        }


    }, [updatedData])
    return (
        <>
            <Container maxWidth="md">
                <Box mb={5} />
                {!success && (



                    <form autoComplete="off" onSubmit={handleSubmit}>
                        <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }} sx={{ border: 'solid', borderWidth: '3px', borderColor: "error.main", borderRadius: 2 }}>



                            <Grid item xs={12} >
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"

                                >

                                    <Typography variant="h6" component="h3" color="error">
                                        Remove Course
                                    </Typography>


                                </Box>

                            </Grid>
                            <Grid item xs={12} >
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"

                                >

                                    <Typography variant="body2" component="p" color="error">
                                        Are you sure you want to remove this course from your cart?
                                    </Typography>


                                </Box>

                            </Grid>


                            {error && !errorMessage && (

                                <Grid item xs={12} >
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"

                                    >

                                        <Typography variant="h6" component="h3" className='error' fullWidth sx={{ textAlign: 'center' }}>
                                            Unable to get course infromation. You may be offline.
                                        </Typography>

                                    </Box>
                                </Grid>
                            )}

                            {error2 && (

                                <Grid item xs={12} >
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"

                                    >

                                        <Typography variant="h6" component="h3" className='error' fullWidth sx={{ textAlign: 'center' }}>
                                            Unable to remove course. You may be offline.
                                        </Typography>

                                    </Box>
                                </Grid>
                            )}

                            {errorMessage && (

                                <Grid item xs={12} >
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"

                                    >

                                        <Typography variant="h6" component="h3" className='error' fullWidth sx={{ textAlign: 'center' }}>
                                            {errorMessage}
                                        </Typography>

                                    </Box>
                                </Grid>
                            )}

                            {isPending && (

                                <Grid item xs={12} >
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"

                                    >

                                        <CircularProgress />
                                        <Typography variant="h6" component="h3" color="secondary">
                                            Fetching data ...
                                        </Typography>

                                    </Box>
                                </Grid>
                            )}
                            {isPending2 && (

                                <Grid item xs={12} >
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"

                                    >

                                        <CircularProgress />
                                        <Typography variant="h6" component="h3" color="secondary">
                                            Removing data....
                                        </Typography>

                                    </Box>
                                </Grid>
                            )}
                            {!isPending && !isPending2 &&
                                (

                                    <>

                                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"

                                            >

                                                <TextField

                                                    id="courseCode"
                                                    label="Code:"
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                    value={courseCode}
                                                    fullWidth

                                                />


                                            </Box>


                                        </Grid>
                                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"

                                            >

                                                <TextField

                                                    id="courseName"
                                                    label="Course:"
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                    value={courseName}
                                                    fullWidth

                                                />


                                            </Box>


                                        </Grid>








                                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                sx={{

                                                    maxWidth: '95%',
                                                    marginLeft: 'auto',
                                                    marginRight: 'auto'
                                                }}
                                            >

                                                {!isPending && (
                                                    <Button fullWidth color={"primary"} variant="contained" onClick={(e) => setRemove(0)}>Cancel <CancelIcon /></Button>


                                                )}



                                            </Box>


                                        </Grid>


                                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                sx={{

                                                    maxWidth: '95%',
                                                    marginLeft: 'auto',
                                                    marginRight: 'auto'
                                                }}
                                            >


                                                {!isPending && (

                                                    <Button fullWidth color="error" type="submit" variant="contained">Remove <DeleteIcon /></Button>

                                                )}




                                            </Box>
                                            <Box mb={5} />

                                        </Grid>
                                    </>
                                )}
                            <Box mb={5} />
                        </Grid>
                    </form>
                )}

                <Box mb={5} />
            </Container >

        </>

    )
}

export default RemoveCouse